import { TierLabel, TierVersion } from "@memento/types/subscription";
import { Feature, FeatureAccessTier } from "./feature.js";
// This file defines the FeatureAccessTier definitions for TierVersion.V1
const noneFeatures = [];
const extraFeatures = [
    Feature.SharedAlbumsStorageLevel1,
    Feature.SharedAlbumsAdminsLevel1,
    Feature.SharedAlbumsAlbumsLevel1,
];
const advancedFeatures = [
    Feature.SharedAlbumsStorageLevel2,
    Feature.SharedAlbumsAdminsLevel2,
    Feature.SharedAlbumsAlbumsLevel2,
];
const preferredFeatures = [
    Feature.SharedAlbumsVideos,
    Feature.SharedAlbumsRemoveAds,
    Feature.SharedAlbumsStorageLevel3,
    Feature.SharedAlbumsAdminsLevel3,
    Feature.SharedAlbumsAlbumsLevel3,
];
const businessFeatures = [
    Feature.SharedAlbumsStorageLevel4,
    Feature.SharedAlbumsAlbumsLevel4,
];
const plusFeatures = [
    Feature.ContributorInviteEditSubject,
    Feature.ViewRecordLink,
    Feature.VideoClipManage,
    Feature.VideoClipDownload,
    Feature.VideoClipDiscard,
    Feature.MontageCreate,
    Feature.MontageRender,
    Feature.ContributorInvite,
    Feature.RecipientReactions,
    Feature.BaseGroupVideosAccess,
];
const premiumFeatures = [
    Feature.CollaboratorAdd,
    Feature.MontageCustomBackgroundColor,
    Feature.MontageCustomWatermark,
];
const platinumFeatures = [
    Feature.MontageDownload,
    Feature.GroupVideosRemoveAds,
    Feature.VideoClipCustomText,
    Feature.ContributorSignUpNotRequired,
];
/**
 * Defines features access for TierLabel.NONE, TierVersion.V1
 */
export class FeatureAccessTierNoneV1 extends FeatureAccessTier {
    constructor() {
        super(...arguments);
        this.features = noneFeatures;
        this.tier = {
            label: TierLabel.NONE,
            version: TierVersion.V1,
        };
    }
}
export class FeatureAccessTierExtraV1 extends FeatureAccessTier {
    constructor() {
        super(...arguments);
        this.features = noneFeatures.concat(extraFeatures);
        this.tier = {
            label: TierLabel.EXTRA,
            version: TierVersion.V1,
        };
    }
}
export class FeatureAccessTierAdvancedV1 extends FeatureAccessTier {
    constructor() {
        super(...arguments);
        this.features = extraFeatures.concat(advancedFeatures);
        this.tier = {
            label: TierLabel.ADVANCED,
            version: TierVersion.V1,
        };
    }
}
export class FeatureAccessTierPreferredV1 extends FeatureAccessTier {
    constructor() {
        super(...arguments);
        this.features = extraFeatures
            .concat(advancedFeatures)
            .concat(preferredFeatures);
        this.tier = {
            label: TierLabel.PREFERRED,
            version: TierVersion.V1,
        };
    }
}
export class FeatureAccessTierPlusV1 extends FeatureAccessTier {
    constructor() {
        super(...arguments);
        this.features = extraFeatures
            .concat(advancedFeatures)
            .concat(preferredFeatures)
            .concat(plusFeatures);
        this.tier = {
            label: TierLabel.PLUS,
            version: TierVersion.V1,
        };
    }
}
export class FeatureAccessTierPremiumV1 extends FeatureAccessTier {
    constructor() {
        super(...arguments);
        this.features = extraFeatures
            .concat(advancedFeatures)
            .concat(preferredFeatures)
            .concat(plusFeatures)
            .concat(premiumFeatures);
        this.tier = {
            label: TierLabel.PREMIUM,
            version: TierVersion.V1,
        };
    }
}
export class FeatureAccessTierPlatinumV1 extends FeatureAccessTier {
    constructor() {
        super(...arguments);
        this.features = extraFeatures
            .concat(advancedFeatures)
            .concat(preferredFeatures)
            .concat(plusFeatures)
            .concat(premiumFeatures)
            .concat(platinumFeatures);
        this.tier = {
            label: TierLabel.PLATINUM,
            version: TierVersion.V1,
        };
    }
}
export class FeatureAccessTierBusinessV1 extends FeatureAccessTier {
    constructor() {
        super(...arguments);
        this.features = extraFeatures
            .concat(advancedFeatures)
            .concat(preferredFeatures)
            .concat(plusFeatures)
            .concat(premiumFeatures)
            .concat(platinumFeatures)
            .concat(businessFeatures);
        this.tier = {
            label: TierLabel.BUSINESS,
            version: TierVersion.V1,
        };
    }
}
